import { Link } from 'react-router-dom';

const footerNav = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '关于我们', to: '/about' },
];

const footerGenres = ['剧情', '悬疑', '动作', '古装', '都市', '综艺'];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-800 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className="ri-clapperboard-line text-2xl"></i>
              </span>
              <span className="font-heading font-black text-lg text-white">亚洲中文字幕</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200 max-w-xs">
              亚洲中文字幕在线观看，汇集电影、电视剧与综艺节目，支持中文字幕播放，为影迷提供清晰便捷的浏览体验。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white mb-4">网站导航</h3>
            <ul className="space-y-2.5">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white mb-4">热门类型</h3>
            <div className="flex flex-wrap gap-2">
              {footerGenres.map((g, i) => (
                <Link
                  key={g}
                  to={`/category/${['movie', 'movie', 'movie', 'tv', 'tv', 'variety'][i]}`}
                  className="px-3 py-1.5 rounded-full bg-primary-700 hover:bg-accent-500 text-xs text-primary-100 hover:text-white transition-colors cursor-pointer"
                >
                  {g}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white mb-4">联系我们</h3>
            <ul className="space-y-3 text-sm text-primary-200">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-accent-400 text-lg"></i>
                <a href="mailto:contact@asia-subtitle-demo.com" className="hover:text-accent-400 transition-colors cursor-pointer">
                  contact@asia-subtitle-demo.com
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-accent-400 text-lg"></i>
                <span>每日持续更新</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-information-line text-accent-400 text-lg mt-0.5"></i>
                <span>本站为演示站点，不提供真实播放与下载服务。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2025 亚洲中文字幕在线观看 · 演示项目，仅供学习交流使用</p>
          <p>All resources are for demonstration only.</p>
        </div>
      </div>
    </footer>
  );
}